"use client";

import { ArrowRight, Radio } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MosquitoControl() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="mosquito-control" id="mosquito-control" className="bg-background text-foreground py-20 md:py-28 border-b border-border scroll-mt-24">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="border border-border bg-card rounded-md p-8 shadow-sm">
              <div className="size-12 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-6">
                <Radio size={28} />
              </div>
              <h3 className="text-xl font-bold font-default text-foreground mb-3">
                Yard Barrier Applications
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Warm North Carolina summers foster heavy mosquito activity. Our focused misting reaches the underside of broad leaves, perimeter hedges, and shaded resting spots where mosquitoes harbor during hot daylight hours.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="block h-px w-8 bg-primary" />
              <span className="font-mono text-xs uppercase tracking-widest text-primary">
                Seasonal Outdoor Comfort
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
              Mosquito Control
            </h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-8 font-sans">
              Seasonal barrier sprays on shaded foliage and resting areas, plus source reduction, curb mosquito breeding and biting pressure so you can enjoy your yard throughout warm North Carolina months.
            </p>

            <Button asChild className="rounded-md h-auto px-7 py-3.5 text-base font-bold font-default bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-md">
              <Link to="/MosquitoControlPage">
                Learn More
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}